module.exports = __webpack_public_path__ + "img/20_dice[12].893ae309.png";